import { useState } from 'react'
import { api } from '@/lib/api'
import { clientColor } from './schedule/clientColors'

export interface ClientAvatarProps {
  client: { id: number; name: string; avatarPath?: string | null }
  /** 直径（px），默认 32 */
  size?: number
}

/**
 * 学员头像（OPT-006）：
 * - 有 avatarPath 时渲染 img（鉴权走 HttpOnly cookie，src 直接指向 /api/clients/:id/avatar），
 *   加载失败（如无头像 404）回退占位；
 * - 无头像时渲染圆形占位：背景色 clientColor(id)，白色文字显示名字首字符（中/英文均取第一个字符）。
 */
export function ClientAvatar({ client, size = 32 }: ClientAvatarProps) {
  const [loadFailed, setLoadFailed] = useState(false)

  if (client.avatarPath && !loadFailed) {
    return (
      <img
        data-testid="client-avatar-img"
        src={api.clientAvatarUrl(client.id)}
        alt={client.name}
        onError={() => setLoadFailed(true)}
        className="rounded-full object-cover shrink-0"
        style={{ width: size, height: size }}
      />
    )
  }

  return (
    <div
      data-testid="client-avatar-placeholder"
      aria-hidden
      className="rounded-full shrink-0 flex items-center justify-center text-white font-medium select-none"
      style={{
        width: size,
        height: size,
        backgroundColor: clientColor(client.id),
        fontSize: Math.round(size * 0.4),
      }}
    >
      {client.name.charAt(0)}
    </div>
  )
}
